module.exports = __webpack_public_path__ + "static/media/victor_icon.c62b600d.png";